'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Laptop = require('./Laptop');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Laptop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Laptop/index.js
// module id = 1218
// module chunks = 1